import { render } from "./FinalPage.vue?vue&type=template&id=4340b784&scoped=true"
import script from "./FinalPage.vue?vue&type=script&lang=js"
export * from "./FinalPage.vue?vue&type=script&lang=js"

import "./FinalPage.vue?vue&type=style&index=0&id=4340b784&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4340b784"]])

export default __exports__